import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Article } from '../../../../shared/public-api';

@Component({
  selector: 'admin-article-seo',
  templateUrl: './article-seo.component.html',
  styleUrls: ['./article-seo.component.scss'],
  imports: [CommonModule, FormsModule],
})
export class ArticleSeoComponent {
  @Input() articleModel: Article;
  @Output() articleModelChange = new EventEmitter<Article>();
}
